import * as actionTypes from "./actionTypes";
// import { images } from "../../data";
import { generateUniqueId, uploadImage } from "../utility";
import {firebase,storage} from "../../firebase/index";
import {collections} from "../../firebase/firestoreNameSpaces"
export const onFetchImages = (categoryId, subcategoryId) => {
  return  (dispatch) => {
    dispatch({
      type: actionTypes.GALLERY_CONTROLS,
      payload: { loading: true },
    });
    let db = firebase.firestore();
    db.collection(collections.GALLERY).doc(categoryId)
    .onSnapshot(snapshot=>{
    
      // let images = [];
      let galleryCategory = snapshot.data();
      
        if(galleryCategory){
          if(galleryCategory[subcategoryId]){
            // images.concat(galleryCategory[subcategoryId]).reverse();
          dispatch({
            type: actionTypes.GALLERY_CONTROLS,
            payload: { images:galleryCategory[subcategoryId].reverse() , loading: false },
          });
          }else{ 
            dispatch({
              type: actionTypes.GALLERY_CONTROLS,
              payload: { images:[], loading: false },
            });
          }
      }else{
        dispatch({
          type: actionTypes.GALLERY_CONTROLS,
          payload: { images:[], loading: false },
        });
      }
    })
    
  };
};

export const onUploadImages = (categoryId, subcategoryId, images) => {
  
  return async (dispatch) => {


  return new Promise(async (resolve,reject)=>{

      let imageUrls = [];
      try{
  
        if(!images.length){
          return alert("Please Select Images to upload")
        }
        dispatch({
          type: actionTypes.GALLERY_CONTROLS,
          payload: { uploadImagesLoading: true },
        });
        
        
        for(let i=0;i<images.length;i++){
          let image = images[i];
          let path = `${categoryId}/${subcategoryId}/${generateUniqueId(4)+image.name}`;
          let imgUrl =  await uploadImage(path,image);
          imageUrls.push(imgUrl);
        }
        
        let db = firebase.firestore();
        await db.collection(collections.GALLERY).doc(categoryId)
        .set({
          [subcategoryId]:firebase.firestore.FieldValue.arrayUnion(...imageUrls)
        
        },{merge:true}
        )
  
        dispatch({
          type: actionTypes.GALLERY_CONTROLS,
          payload: { uploadImagesLoading: false },
        });
        resolve(imageUrls);
        alert(`${imageUrls.length}/${images.length} images uploaded successfully` )
        imageUrls = [];
        return true;
  
      }catch(error){
  
          if(imageUrls.length){
  
          let db = firebase.firestore();
          db.collection(collections.GALLERY).doc(categoryId)
          .set({
            [subcategoryId]:firebase.firestore.FieldValue.arrayUnion(imageUrls)
          
          },{merge:true}
          ).then(()=>{
            dispatch({
              type: actionTypes.GALLERY_CONTROLS,
              payload: { uploadImagesLoading: false },
            });
            resolve(imageUrls);
            alert(`${imageUrls.length}/${images.length} images uploaded successfully` )
            imageUrls = [];
            return true;
  
          }).catch(error=>{
              reject(error)
              return alert(error)
          })
  
  
        }else{
            reject(error)
            return alert(error)
        }
  
  
        
      }


    })
  
    
  }; 
}; 

export const onDeleteImages = (categoryId, subcategoryId, images) => {
  return (dispatch) => {
    return new Promise(async (resolve,reject)=>{
      let deletedImages = [];
      try{

        if(!images.length){
          return alert("Please Select Images to Delete")
        }
        dispatch({
          type: actionTypes.GALLERY_CONTROLS,
          payload: { deleteImagesLoading: true },
        });
        // console.log((categoryId, subcategoryId, images));
  
        for(let i=0;i<images.length;i++){
            await storage.refFromURL(images[i]).delete();
            deletedImages.push(images[i])
        }
  
        let db = firebase.firestore();
  
        await db.collection(collections.GALLERY).doc(categoryId)
        .set({
          [subcategoryId]:firebase.firestore.FieldValue.arrayRemove(...images)
        },{merge:true})
    
        dispatch({
          type: actionTypes.GALLERY_CONTROLS,
          payload: { deleteImagesLoading: false },
        });
        
        resolve(deletedImages);
        alert(`${deletedImages.length}/${images.length} images deleted successfully` )
        deletedImages = [];
        return true;


      }catch(error){

        if(deletedImages.length){


          let db = firebase.firestore();
  
          db.collection(collections.GALLERY).doc(categoryId)
          .set({
            [subcategoryId]:firebase.firestore.FieldValue.arrayRemove(...images)
          },{merge:true})
          .then(()=>{

            dispatch({
              type: actionTypes.GALLERY_CONTROLS,
              payload: { deleteImagesLoading: false },
            });
            
            resolve(deletedImages);
            alert(`${deletedImages.length}/${images.length} images deleted successfully` )
            deletedImages = [];
            return true;

          }).catch(error=>{

              reject(error)
              return alert(error)

          })   

        }else{
          reject(error);
          return alert(error);
        }
      }
      
    })
  
  };
};
